import { createCommand } from 'lexical'

import {
  TableColumnWidthChangePayload,
  TableRowHeightChangePayload
} from './interface'

export const TABLE_COLUMN_WIDTH_CHANGE_COMMAND =
  createCommand<TableColumnWidthChangePayload>(
    'TABLE_COLUMN_WIDTH_CHANGE_COMMAND'
  )

export const TABLE_ROW_HEIGHT_CHANGE_COMMAND =
  createCommand<TableRowHeightChangePayload>('TABLE_ROW_HEIGHT_CHANGE_COMMAND')
